import { render, staticRenderFns } from "./PlantillasCorreo.vue?vue&type=template&id=7393636d&scoped=true"
import script from "./PlantillasCorreo.vue?vue&type=script&lang=js"
export * from "./PlantillasCorreo.vue?vue&type=script&lang=js"
import style0 from "./PlantillasCorreo.vue?vue&type=style&index=0&id=7393636d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7393636d",
  null
  
)

export default component.exports